import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { api } from "@/api";
import { trackEvent } from "@/analytics";
import Layout from "@/components/tex/Layout";
import HomePage from "@/pages/HomePage";
import ToolsPage from "@/pages/ToolsPage";
import AboutPage from "@/pages/AboutPage";
import TeamPage from "@/pages/TeamPage";
import CoveragePage from "@/pages/CoveragePage";
import FaqPage from "@/pages/FaqPage";
import ContactPage from "@/pages/ContactPage";
import AdminPage from "@/pages/AdminPage";
import ProductsPage from "@/pages/ProductsPage";
import QuoteModal from "@/components/tex/QuoteModal";

function App() {
  const [company, setCompany] = useState(null);
  const [chemicals, setChemicals] = useState([]);
  const [activeChem, setActiveChem] = useState("hcl");
  const [error, setError] = useState(null);
  const [quote, setQuote] = useState({ open: false, source: null });

  useEffect(() => {
    api
      .listChemicals()
      .then(setChemicals)
      .catch((e) => setError(e.message));
    api
      .getCompany()
      .then((c) => {
        setCompany(c);
        document.title = `${c.name} — Safety & Compliance Hub`;
        const desc = document.querySelector('meta[name="description"]');
        if (desc) {
          desc.setAttribute(
            "content",
            `${c.name} — bulk supplier of HCl, H₂SO₄, NaOH, Na₂CO₃, weak HNO₃ and formaldehyde. Free safety tools: first-aid, PPE, SDS, COA and BIS/IS/FSSAI standards.`
          );
        }
      })
      .catch((e) => setError(e.message));
  }, []);

  function selectChem(key) {
    setActiveChem(key);
    trackEvent("chemical_selected", { chemical: key });
  }

  function openQuote(source) {
    setQuote({ open: true, source });
  }

  const active = chemicals.find((c) => c.key === activeChem);

  const outletContext = {
    company,
    chemicals,
    activeChem,
    selectChem,
    openQuote,
  };

  if (error) {
    return (
      <div className="tex-app" style={{ padding: 40 }}>
        <h2>Couldn&apos;t reach the API</h2>
        <p>{error}</p>
        <p className="note">
          Verify the backend service is running and that REACT_APP_BACKEND_URL points to the FastAPI host.
        </p>
      </div>
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout company={company} openQuote={openQuote} outletContext={outletContext} />}>
          <Route index element={<HomePage />} />
          <Route path="products" element={<ProductsPage />} />
          <Route path="tools" element={<ToolsPage />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="team" element={<TeamPage />} />
          <Route path="coverage" element={<CoveragePage />} />
          <Route path="faq" element={<FaqPage />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="admin" element={<AdminPage />} />
          <Route path="*" element={<HomePage />} />
        </Route>
      </Routes>

      <QuoteModal
        open={quote.open}
        onClose={() => setQuote({ open: false, source: null })}
        chemicalKey={activeChem}
        chemicalName={active?.name}
        source={quote.source}
      />
    </BrowserRouter>
  );
}

export default App;
